<template>
    <div v-if="!loadingPage">
        <div v-if="isAdminIdentityVerified" class="pb-2">
            <div class="d-flex justify-content-between align-items-center">
                <h3 class="mb-2 text-primary">اعتبار و کیف پول</h3>
                <div class="d-flex align-items-center mb-2">
                    <b-button type="submit" variant="primary" :disabled="loadingCustomers" @click="customerChoice(true)"
                        class="d-flex align-items-center justify-content-center mr-50">
                        <b-spinner v-if="loadingCustomers" class="mr-50" variant="white" small></b-spinner>
                        <span>ویرایش </span>
                    </b-button>
                    <b-button type="submit" variant="primary" :disabled="loadingCustomers"
                        @click="customerChoice(false)" class="d-flex align-items-center justify-content-center">
                        <b-spinner v-if="loadingCustomers" class="mr-50" variant="white" small></b-spinner>
                        <span>افزایش </span>
                    </b-button>
                </div>
            </div>
            <b-row>
                <b-col lg="3" md="4" class="mt-25">
                    <b-form-group label="نام یا شماره اشتراک" label-for="searchCustomer">
                        <v-select dir="rtl" v-model="searchCustomer" :options="customerListSearch" :filterable="false"
                            style="border-radius: 6px;" class="bg-white" :clearable="false" id="searchCustomer"
                            @search="handleSearchCustomer" :loading="loadingCustomer"
                            :get-option-label="(option) => option.number + ' - ' + option.firstName + ' ' + option.lastName">
                            <template #option="{ number, firstName, lastName, phoneNumber }">
                                <div class="d-flex align-items-center">
                                    <div>{{ number }}</div>
                                    <span class="mx-50">-</span>
                                    <div class="mr-50">{{ firstName }}</div>
                                    <div>{{ lastName }}</div>
                                    <span class="mx-50">/</span>
                                    <div>{{ phoneNumber }}</div>
                                </div>
                            </template>
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                            <template #spinner="{ loading }">
                                <div v-if="loadingCustomer" style="border-right-color: #7367f0" class="vs__spinner">
                                </div>
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="4" class="mt-25">
                    <b-form-group label="تاریخ شروع" label-for="fromId">
                        <b-form-input id="fromId" class="text-center main-input font-weight-bolder pointer"
                            :value="parameters.from ? formatDate(parameters.from) : null" autocomplete="off"
                            name="fromId" />
                        <date-picker v-model="parameters.from" :max="currentDate" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" custom-input="#fromId" />
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="4" class="mt-25">
                    <b-form-group label="تاریخ پایان" label-for="toId">
                        <b-form-input id="toId" class="text-center main-input font-weight-bolder pointer" name="toId"
                            :value="parameters.to ? formatDate(parameters.to) : null" autocomplete="off" />
                        <date-picker v-model="parameters.to" :max="currentDate" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" custom-input="#toId" />
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="3" class="mt-25">
                    <b-form-group label="نوع" label-for="typeId">
                        <v-select v-model="parameters.type" :searchable="false" dir="rtl" :options="typeManagement"
                            class="bg-white" id="isReturnedId" autocomplete="off" :reduce="(value) => value.id"
                            style="border-radius: 6px;" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="3" class="mt-25">
                    <b-form-group label="کاربر تغییر دهنده" label-for="userIdId">
                        <v-select v-model="parameters.storeUserId" dir="rtl" :options="usersList" id="userIdId"
                            class="bg-white" autocomplete="off" :reduce="(value) => value.id"
                            style="border-radius: 6px;"
                            :get-option-label="(option) => option.firstName + ' ' + option.lastName" :clearable="false">
                            <template #option="{ firstName, lastName }">
                                {{ firstName }} {{ lastName }}
                            </template>
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="2" md="3" class="mt-md-2 mt-50">
                    <b-button @click="removeFilters" variant="secondary"
                        class="mt-md-25 mt-0 d-flex justify-content-center w-100" :disabled="loading">
                        <span>حذف فیلتر ها</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                </b-col>
                <b-col lg="2" md="3" class="mt-md-2 mt-1">
                    <b-button variant="info" @click="customersWalletTransactions" :disabled="loading"
                        class="mt-md-25 mt-0 d-flex justify-content-center w-100">
                        <span>اعمال فیلتر</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                </b-col>
            </b-row>
            <div class="mt-2 mt-md-1">
                <b-card class="p-0" no-body>
                    <b-overlay v-if="scoreRecords.length" :show="loading" variant="transparent" opacity="1" blur="3px"
                        rounded="sm">
                        <b-table responsive :items="scoreRecords" :fields="fields" class="mb-0" striped>
                            <template #cell(type)="data">
                                {{ type_management(data.item.type) }}
                            </template>
                            <template #cell(newWalletBalance)="data">
                                {{ data.item.newWalletBalance.toLocaleString('fa-IR') }}
                            </template>
                            <template #cell(previousWalletBalance)="data">
                                {{ data.item.previousWalletBalance.toLocaleString('fa-IR') }}
                            </template>
                            <template #cell(amount)="data">
                                <span :class="data.item.isIncremental ? 'text-success' : 'text-danger'">
                                    {{
                                        data.item.isIncremental ? `${data.item.amount.toLocaleString('fa-IR')} +` :
                                            `${data.item.amount.toLocaleString('fa-IR')} -`
                                    }}
                                </span>
                            </template>
                            <template #cell(customer)="data">
                                {{ `${data.item.customer.firstName} ${data.item.customer.lastName}` }}
                            </template>
                            <template #cell(createdByStoreUser)="data">
                                <span v-if="data.item.createdByStoreUser">
                                    {{ `${data.item.createdByStoreUser.firstName}
                                    ${data.item.createdByStoreUser.lastName}` }}
                                </span>
                                <span v-else>
                                    -
                                </span>
                            </template>
                            <template #cell(customer.number)="data">
                                {{ data.item.customer.number }}
                            </template>
                            <template #cell(createdAt)="data">
                                <span>
                                    {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                                </span>
                                <span> - </span>
                                <span>
                                    {{ new
                                        Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                            2).join(":") }}
                                </span>
                            </template>
                        </b-table>
                    </b-overlay>
                    <div v-else class="text-center py-4">
                        موردی وجود ندارد
                    </div>
                </b-card>
                <b-pagination align="center" @input="customersWalletTransactions" v-model="parameters.pageIndex"
                    :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
            </div>


            <!------------------------------- modal wallet recharge ------------------------------->
            <b-modal id="wallet-recharge" :title="!setWalletBalance ? 'افزایش اعتبار' : 'ویرایش اعتبار'" centered
                :hide-footer="true" title-class="font-weight-bolder" size="md">

                <validation-observer ref="walletRecharge">
                    <b-form @submit.prevent class="px-1 pt-50">
                        <b-row>
                            <b-col md="12">
                                <div @click="managementCustomerSelection(1)" class="pointer mb-1">
                                    <div class="text-center">مشتریان انتخاب شده</div>
                                    <div class="border rounded mt-50 p-50 text-center">
                                        {{ selectedCount }} مشتری
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" class="mt-25">
                                <b-form-group label-for="amount" label="مبلغ (ریال)" class="text-center">
                                    <validation-provider name="مبلغ" #default="{ errors }" rules="required">
                                        <cleave id="amount" dir="ltr" v-model="formAmount"
                                            :class="errors.length > 0 ? 'border-danger' : null"
                                            class="form-control mt-50 text-center" autocomplete="off"
                                            :options="options.number" inputmode="numeric" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col md="12" class="mt-25">
                                <b-alert variant="warning" show>
                                    <div v-if="setWalletBalance" class="alert-body text-center">
                                        اعتبار مشتریان انتخاب‌شده، با مبلغ واردشده جایگزین خواهد شد.
                                    </div>
                                    <div v-if="!setWalletBalance" class="alert-body text-center">
                                        اعتبار مشتریان انتخاب‌شده با توجه به مبلغ واردشده افزایش خواهد یافت.
                                    </div>
                                </b-alert>
                            </b-col>
                            <b-col md="12">
                                <b-button variant="info" @click="walletRecharge" :disabled="loadingButton"
                                    class="w-100 mt-1 mb-75">
                                    {{ !setWalletBalance ? 'افزایش اعتبار' : 'ویرایش اعتبار' }}
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </validation-observer>
            </b-modal>


            <!------------------------------- modal customers find ------------------------------->
            <b-modal id="customer-choice" title="انتخاب مشتریان" centered :hide-footer="true"
                title-class="font-weight-bolder" size="lg">
                <b-row>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="نام - نام خانوادگی - شماره اشتراک" label-for="searchTermId">
                            <b-form-input @keyup.enter="getCustomers" v-model="parametersCustomers.searchTerm"
                                id="searchTermId" autocomplete="off" class="text-center" name="searchTermId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="شماره همراه" label-for="phoneNumberId">
                            <b-form-input dir="ltr" type="number" @keyup.enter="getCustomers"
                                v-model="parametersCustomers.phoneNumber" id="phoneNumberId" autocomplete="off"
                                class="text-center" name="phoneNumberId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="شماره سطح" label-for="levelNumberId">
                            <b-form-input dir="ltr" type="number" v-model="parametersCustomers.levelNumber"
                                id="levelNumberId" @keyup.enter="getCustomers" autocomplete="off" class="text-center"
                                name="levelNumberId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="از امتیاز" label-for="startScoreId">
                            <b-form-input dir="ltr" type="number" v-model="parametersCustomers.minScore"
                                id="startScoreId" @keyup.enter="getCustomers" autocomplete="off" class="text-center"
                                name="startScoreId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="تا امتیاز" label-for="endScoreId">
                            <b-form-input dir="ltr" type="number" v-model="parametersCustomers.maxScore" id="endScoreId"
                                @keyup.enter="getCustomers" autocomplete="off" class="text-center" name="endScoreId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="از تعداد خرید" label-for="minTotalOrdersCountId">
                            <b-form-input dir="ltr" type="number" v-model="parametersCustomers.minTotalOrdersCount"
                                @keyup.enter="getCustomers" id="minTotalOrdersCountId" autocomplete="off"
                                class="text-center" name="minTotalOrdersCountId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="تا تعداد خرید" label-for="maxTotalOrdersCountId">
                            <b-form-input dir="ltr" type="number" v-model="parametersCustomers.maxTotalOrdersCount"
                                @keyup.enter="getCustomers" id="maxTotalOrdersCountId" autocomplete="off"
                                class="text-center" name="maxTotalOrdersCountId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="از آخرین خرید (روز)" label-for="minDaysNumberSinceLastOrderedId">
                            <b-form-input dir="ltr" type="number"
                                v-model="parametersCustomers.minDaysNumberSinceLastOrdered" @keyup.enter="getCustomers"
                                id="minDaysNumberSinceLastOrderedId" autocomplete="off" class="text-center"
                                name="minDaysNumberSinceLastOrderedId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="تا آخرین خرید (روز)" label-for="maxDaysNumberSinceLastOrderedId">
                            <b-form-input dir="ltr" type="number"
                                v-model="parametersCustomers.maxDaysNumberSinceLastOrdered" @keyup.enter="getCustomers"
                                id="maxDaysNumberSinceLastOrderedId" autocomplete="off" class="text-center"
                                name="maxDaysNumberSinceLastOrderedId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="از مبلغ خرید" label-for="minTotalOrdersAmountId">
                            <b-form-input dir="ltr" type="number" v-model="parametersCustomers.minTotalOrdersAmount"
                                @keyup.enter="getCustomers" id="minTotalOrdersAmountId" autocomplete="off"
                                class="text-center" name="minTotalOrdersAmountId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="تا مبلغ خرید" label-for="maxTotalOrdersAmountId">
                            <b-form-input dir="ltr" type="number" v-model="parametersCustomers.maxTotalOrdersAmount"
                                @keyup.enter="getCustomers" id="maxTotalOrdersAmountId" autocomplete="off"
                                class="text-center" name="maxTotalOrdersAmountId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="وفاداری" label-for="groupId">
                            <v-select v-model="parametersCustomers.groupId" :searchable="false" dir="rtl"
                                :options="groupIdData" :reduce="(value) => value.id" label="name" id="groupId"
                                class="bg-white" style="border-radius: 6px;" :clearable="false">
                                <template #no-options>
                                    موردی وجود ندارد
                                </template>
                            </v-select>
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="محصول مورد علاقه" label-for="favoriteProductId">
                            <v-select v-model="parametersCustomers.favoriteProductId" dir="rtl" :options="products"
                                :reduce="(value) => value.id" label="name_Fa" id="favoriteProductId" class="bg-white"
                                style="border-radius: 6px;" :clearable="false">
                                <template #no-options>
                                    موردی وجود ندارد
                                </template>
                            </v-select>
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="نوع ترتیب نمایش" label-for="sortById">
                            <v-select v-model="parametersCustomers.sortBy" :searchable="false" dir="rtl"
                                :options="sortByData" :reduce="(value) => value.id" label="name" id="sortById"
                                class="bg-white" style="border-radius: 6px;" :clearable="false">
                                <template #no-options>
                                    موردی وجود ندارد
                                </template>
                            </v-select>
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="4" class="mt-25">
                        <b-form-group label="ترتیب نمایش" label-for="sortDescendingId">
                            <v-select v-model="parametersCustomers.sortDescending" :searchable="false" dir="rtl"
                                id="sortDescendingId" :options="sortDescendingData" :reduce="(value) => value.id"
                                label="name" class="bg-white" style="border-radius: 6px;" :clearable="false">
                                <template #no-options>
                                    موردی وجود ندارد
                                </template>
                            </v-select>
                        </b-form-group>
                    </b-col>
                    <b-col lg="6" md="4" class="mt-50 mt-md-2 mt-lg-25">
                        <b-button @click="removeFiltersCustomers" variant="secondary"
                            class="mt-md-25 mt-0 d-flex justify-content-center w-100" :disabled="loadingCustomers">
                            <span>حذف فیلتر ها</span>
                            <b-spinner v-if="loadingCustomers" variant="white" class="ml-50" small></b-spinner>
                        </b-button>
                    </b-col>
                    <b-col lg="6" md="4" class="mt-2 mt-md-2 mt-lg-25">
                        <b-button variant="info" @click="getCustomers" :disabled="loadingCustomers"
                            class="mt-md-25 mt-0 d-flex justify-content-center w-100">
                            <span>اعمال فیلتر</span>
                            <b-spinner v-if="loadingCustomers" variant="white" class="ml-50" small></b-spinner>
                        </b-button>
                    </b-col>
                    <b-col md="12" class="mt-2 mt-md-50 mt-lg-2">
                        <div class="d-flex align-items-center justify-content-between border border-info rounded px-1"
                            style="height: 41px;">
                            <div class="d-flex align-items-center">
                                <feather-icon size="18" icon="UsersIcon" class="mr-50" />
                                <h5 class="mb-0">مشتریان انتخاب شده</h5>
                            </div>
                            <div class="d-flex align-items-center">
                                <div class="d-flex align-items-center mb-0 mr-50">
                                    <h3 v-if="!loadingCustomers" class="font-weight-bolder mb-0">
                                        {{ selectedCount }}
                                    </h3>
                                    <b-spinner v-else small></b-spinner>
                                </div>
                                <span>مشتری</span>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-card class="p-0 mt-2" no-body>
                    <b-overlay :show="loadingCustomers" variant="transparent" opacity="1" blur="3px" rounded="sm">
                        <b-table v-if="customerList.length" responsive :items="customerList" :fields="fieldsCustomer"
                            class="mb-0" striped>
                            <template #head(select)>
                                <b-form-checkbox :indeterminate="isIndeterminate" v-model="isAllSelected"
                                    @change="toggleSelectAll"></b-form-checkbox>
                            </template>
                            <template #cell(select)="data">
                                <b-form-checkbox :checked="isRowChecked(data.item.id)"
                                    @change="toggleRow(data.item.id, $event)"></b-form-checkbox>
                            </template>
                            <template #cell(lastName)="data">
                                {{ data.item.lastName ? data.item.lastName : '-' }}
                            </template>
                            <template #cell(firstName)="data">
                                {{ data.item.firstName ? data.item.firstName : '-' }}
                            </template>
                        </b-table>
                        <div v-else class="text-center pt-5 pb-4">
                            موردی وجود ندارد
                        </div>
                    </b-overlay>
                </b-card>
                <b-pagination align="center" @input="getCustomers" v-model="parametersCustomers.pageIndex"
                    :total-rows="parametersCustomers.totalCount" :per-page="parametersCustomers.pageSize" />
                <b-button :disabled="!selectedCount" variant="info" @click="managementCustomerSelection(2)"
                    class="w-100 mt-2 mb-50">
                    تایید
                </b-button>
            </b-modal>
        </div>

        <b-card v-else>
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>
    </div>
</template>


<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormCheckbox, BAlert, BFormRadio, BFormTextarea, BTable, BBadge, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BFormFile, BMediaBody, BFormInput, BFormGroup, BSpinner } from 'bootstrap-vue';
import { storeService } from '@core/services';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import vSelect from 'vue-select';
import { accessHandling } from '@core/mixins/accessHandling';
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.ir'

export default {
    components: {
        Cleave,
        ValidationProvider,
        ValidationObserver,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BBadge,
        BMediaBody,
        BFormInput,
        BFormGroup,
        BForm,
        BFormRadio,
        BFormTextarea,
        BFormFile,
        BFormCheckbox,
        BAlert,
        vSelect
    },
    mixins: [accessHandling],
    data() {
        return {
            options: {
                number: {
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                },
            },
            isAdminIdentityVerified: false,
            required,
            loadingButton: false,
            loadingPage: true,
            loading: false,
            currentDate: '',
            storeId: null,
            customerPhoneNumber: null,
            customerData: {},
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                storeUserId: null,
                type: null,
                from: null,
                to: null,
                customerId: null,
            },
            selectAll: false,
            isAllSelected: false,
            isIndeterminate: false,
            scoreRecords: [],
            fieldsCustomer: [
                {
                    key: 'select',
                    label: '',
                },
                {
                    key: 'firstName',
                    label: 'نام',
                },
                {
                    key: 'lastName',
                    label: 'نام خانوادگی',
                },
                {
                    key: 'phoneNumber',
                    label: 'شماره همراه',
                },
                {
                    key: 'number',
                    label: 'شماره اشتراک',
                },
            ],
            fields: [
                {
                    key: 'createdAt',
                    label: 'تاریخ',
                },
                {
                    key: 'customer.number',
                    label: 'شماره اشتراک',
                },
                {
                    key: 'customer',
                    label: 'نام',
                },
                {
                    key: 'previousWalletBalance',
                    label: 'موجودی قبل تغییر (ریال)',
                },
                {
                    key: 'amount',
                    label: 'اعتبار (ریال)',
                },
                {
                    key: 'newWalletBalance',
                    label: 'موجودی بعد تغییر (ریال)',
                },
                {
                    key: 'createdByStoreUser',
                    label: 'کاربر تغییر دهنده',
                },
                {
                    key: 'type',
                    label: 'نوع',
                },
            ],
            customerList: [],
            excludeCustomerIds: [],
            customerListSearch: [],
            loadingCustomer: false,
            loadingCustomers: false,
            searchCustomer: null,
            debounceTimeout: null,
            parametersCustomerSearch: {
                pageIndex: 1,
                pageSize: 90,
                searchTerm: null,
            },
            usersList: [],
            parametersUsers: {
                pageIndex: 1,
                pageSize: 90,
            },
            typeManagement: [
                { name: 'نمایش همه', id: null },
                { name: 'ثبت سفارش', id: 0 },
                { name: 'استفاده از اعتبار', id: 2 },
                { name: 'تنظیم دستی', id: 1 },
                { name: 'ثبت نظر', id: 3 },
            ],
            products: [],
            sortByData: [
                { name: 'تاریخ ایجاد', id: 0 },
                { name: 'امتیاز', id: 1 },
                { name: 'اعتبار', id: 2 },
                { name: 'زمان آخرین خرید', id: 3 },
                { name: 'تعداد خرید', id: 4 },
                { name: 'مبلغ خرید', id: 5 },
            ],
            groupIdData: [
                { name: 'همراهِ همیشگی', id: 1 },
                { name: 'همراهِ هفتگی', id: 2 },
                { name: 'همراهِ ماهانه', id: 3 },
                { name: 'لبه‌ی فراموشی', id: 4 },
                { name: 'مشتریان خاموش', id: 5 },
            ],
            sortDescendingData: [
                { name: 'صعودی', id: false },
                { name: 'نزولی', id: true }
            ],
            parametersCustomers: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                phoneNumber: null,
                searchTerm: null,
                sortBy: null,
                levelNumber: null,
                sortDescending: null,
                maxScore: null,
                minScore: null,
                groupId: null,
                maxTotalOrdersCount: null,
                minTotalOrdersCount: null,
                maxTotalOrdersAmount: null,
                minTotalOrdersAmount: null,
                maxDaysNumberSinceLastOrdered: null,
                minDaysNumberSinceLastOrdered: null,
                favoriteProductId: null,
            },
            onlyCustomerIds: [],
            formAmount: null,
            form: {
                customersFilters: null,
                excludeCustomerIds: [],
                onlyCustomerIds: [],
                amount: null,
            },
            setWalletBalance: false
        }
    },
    computed: {
        selectedCount() {
            if (this.selectAll) {
                return this.parametersCustomers.totalCount - this.excludeCustomerIds.length;
            } else {
                return this.onlyCustomerIds.length;
            }
        },
        type_management() {
            return (status) => {
                if (status == 0) {
                    return 'ثبت سفارش'
                }
                if (status == 1) {
                    return 'تنظیم دستی'
                }
                if (status == 2) {
                    return 'استفاده از اعتبار '
                }
                if (status == 3) {
                    return 'ثبت نظر'
                }
            }
        },
    },
    methods: {
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        formatDate(dateString) {
            const [year, month, day] = dateString.split('-');
            return new Date(year, parseInt(month) - 1, day).toLocaleDateString('fa-IR');
        },
        removeFilters() {
            this.searchCustomer = null;
            this.parametersCustomerSearch.searchTerm = null;
            this.parameters.storeUserId = null;
            this.parameters.type = null;
            this.parameters.from = null;
            this.parameters.to = null;
            this.parameters.customerId = null;
            this.customersWalletTransactions()
        },
        removeFiltersCustomers() {
            this.parametersCustomers.phoneNumber = null;
            this.parametersCustomers.searchTerm = null;
            this.parametersCustomers.sortBy = null;
            this.parametersCustomers.levelNumber = null;
            this.parametersCustomers.sortDescending = null;
            this.parametersCustomers.maxScore = null;
            this.parametersCustomers.minScore = null;
            this.parametersCustomers.groupId = null;
            this.parametersCustomers.maxTotalOrdersCount = null;
            this.parametersCustomers.minTotalOrdersCount = null;
            this.parametersCustomers.maxTotalOrdersAmount = null;
            this.parametersCustomers.minTotalOrdersAmount = null;
            this.parametersCustomers.maxDaysNumberSinceLastOrdered = null;
            this.parametersCustomers.minDaysNumberSinceLastOrdered = null;
            this.parametersCustomers.favoriteProductId = null;
            this.getCustomers()
        },
        handleSearchCustomer(searchTerm) {
            this.loadingCustomer = true
            clearTimeout(this.debounceTimeout)
            if (!searchTerm) {
                this.customerListSearch = []
                this.loadingCustomer = false
                return
            }
            this.debounceTimeout = setTimeout(() => {
                this.getCustomersSearch(searchTerm)
            }, 1000)
        },
        managementCustomerSelection(type) {
            if (type == 1) {
                this.$bvModal.hide('wallet-recharge')
                this.$bvModal.show('customer-choice')
            }
            else {
                this.$bvModal.hide('customer-choice')
                this.$bvModal.show('wallet-recharge')
            }
        },
        getCustomersSearch(searchTerm) {
            this.parametersCustomerSearch.searchTerm = searchTerm
            storeService.getCustomers(this.storeId, this.parametersCustomerSearch).then(({ data }) => {
                this.customerListSearch = data.items
                this.loadingCustomer = false
            })
        },
        customerChoice(mode) {
            this.setWalletBalance = mode
            if (this.accessHandling('employee', 'adjust_customer_wallet')) {
                this.loadingButton = true
                this.onlyCustomerIds = [];
                this.excludeCustomerIds = [];
                this.selectAll = false;
                this.isAllSelected = false;
                this.isIndeterminate = false;
                this.products = []
                this.form.amount = null
                this.formAmount = null
                this.getAllProducts()
                this.removeFiltersCustomers()
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        isRowChecked(id) {
            if (this.selectAll) {
                return !this.excludeCustomerIds.includes(id);
            } else {
                return this.onlyCustomerIds.includes(id);
            }
        },
        toggleRow(id, checked) {
            if (this.selectAll) {
                if (!checked) {
                    if (!this.excludeCustomerIds.includes(id)) {
                        this.excludeCustomerIds.push(id);
                    }
                } else {
                    this.excludeCustomerIds = this.excludeCustomerIds.filter(x => x !== id);
                }
            } else {
                if (checked) {
                    if (!this.onlyCustomerIds.includes(id)) {
                        this.onlyCustomerIds.push(id);
                    }
                } else {
                    this.onlyCustomerIds = this.onlyCustomerIds.filter(x => x !== id);
                }
            }
            this.updateHeaderCheckbox();
        },
        toggleSelectAll(checked) {
            this.selectAll = checked;
            this.isIndeterminate = false;
            if (checked) {
                this.onlyCustomerIds = [];
                this.excludeCustomerIds = [];
            } else {
                this.onlyCustomerIds = [];
                this.excludeCustomerIds = [];
            }
        },
        updateHeaderCheckbox() {
            const pageIds = this.customerList.map(c => c.id);
            let selectedCount = 0;
            if (this.selectAll) {
                selectedCount = pageIds.filter(id => !this.excludeCustomerIds.includes(id)).length;
            } else {
                selectedCount = pageIds.filter(id => this.onlyCustomerIds.includes(id)).length;
            }
            if (selectedCount === pageIds.length) {
                this.isAllSelected = true;
                this.isIndeterminate = false;
            } else if (selectedCount > 0) {
                this.isAllSelected = false;
                this.isIndeterminate = true;
            } else {
                this.isAllSelected = false;
                this.isIndeterminate = false;
            }
        },
        getAllProducts() {
            storeService.getAllProducts(this.storeId).then(({ data }) => {
                let categories = data.categories
                if (categories.length) {
                    categories.forEach(obj => {
                        obj.products.forEach(product => {
                            this.products.push(product)
                        });
                    });
                }
            })
        },
        getCustomers() {
            this.loadingCustomers = true
            storeService.getCustomers(this.storeId, this.parametersCustomers).then(({ data }) => {
                setTimeout(() => {
                    if (this.selectAll && this.parametersCustomers.totalCount !== null && this.parametersCustomers.totalCount !== data.totalCount) {
                        this.excludeCustomerIds = [];
                        this.onlyCustomerIds = [];
                        this.selectAll = false;
                        this.isAllSelected = false;
                        this.isIndeterminate = false;
                    }
                    this.parametersCustomers.totalCount = data.totalCount
                    this.customerList = data.items
                    this.loadingCustomers = false
                    if (this.loadingButton) {
                        this.$bvModal.show('customer-choice')
                    }
                    this.loadingButton = false
                }, 369)
            })
        },
        getUsers() {
            storeService.getUsers(this.storeId, this.parametersUsers).then(({ data }) => {
                this.usersList = data.items
                this.usersList.unshift({
                    id: null,
                    lastName: '',
                    firstName: 'نمایش همه'
                })
            })
            this.customersWalletTransactions()
        },
        customersWalletTransactions() {
            this.loading = true;
            if (this.searchCustomer) {
                this.parameters.customerId = this.searchCustomer.id
            }
            storeService.customersWalletTransactions(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.scoreRecords = data.items
                    this.loading = false;
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.scoreRecords = data.items
                        this.loading = false;
                    }, 369)
                }
                this.loadingPage = false;
            })
        },
        walletRecharge() {
            this.$refs.walletRecharge.validate().then((success) => {
                if (success) {
                    if (this.selectedCount) {
                        this.loadingButton = true
                        this.form.amount = Number(this.formAmount)
                        if (this.selectAll) {
                            this.form.customersFilters = {}
                            this.parametersCustomers.phoneNumber ? this.form.customersFilters.phoneNumber = this.parametersCustomers.phoneNumber : null
                            this.parametersCustomers.searchTerm ? this.form.customersFilters.searchTerm = this.parametersCustomers.searchTerm : null
                            this.parametersCustomers.favoriteProductId ? this.form.customersFilters.favoriteProductId = this.parametersCustomers.favoriteProductId : null
                            this.parametersCustomers.levelNumber ? this.form.customersFilters.levelNumber = this.parametersCustomers.levelNumber : null
                            this.parametersCustomers.groupId ? this.form.customersFilters.groupId = this.parametersCustomers.groupId : null
                            if (this.parametersCustomers.maxScore || this.parametersCustomers.minScore || this.parametersCustomers.minScore == 0) {
                                this.form.customersFilters.scoreRange = {}
                                this.parametersCustomers.minScore ? this.form.customersFilters.scoreRange.from = this.parametersCustomers.minScore : null
                                this.parametersCustomers.maxScore ? this.form.customersFilters.scoreRange.to = this.parametersCustomers.maxScore : null
                            }
                            if (this.parametersCustomers.maxDaysNumberSinceLastOrdered || this.parametersCustomers.minDaysNumberSinceLastOrdered || this.parametersCustomers.minDaysNumberSinceLastOrdered == 0) {
                                this.form.customersFilters.daysNumberSinceLastOrderedRange = {}
                                this.parametersCustomers.minDaysNumberSinceLastOrdered ? this.form.customersFilters.daysNumberSinceLastOrderedRange.from = this.parametersCustomers.minDaysNumberSinceLastOrdered : null
                                this.parametersCustomers.maxDaysNumberSinceLastOrdered ? this.form.customersFilters.daysNumberSinceLastOrderedRange.to = this.parametersCustomers.maxDaysNumberSinceLastOrdered : null
                            }
                            if (this.parametersCustomers.maxTotalOrdersCount || this.parametersCustomers.minTotalOrdersCount || this.parametersCustomers.minTotalOrdersCount == 0) {
                                this.form.customersFilters.totalOrdersCountRange = {}
                                this.parametersCustomers.minTotalOrdersCount ? this.form.customersFilters.totalOrdersCountRange.from = this.parametersCustomers.minTotalOrdersCount : null
                                this.parametersCustomers.maxTotalOrdersCount ? this.form.customersFilters.totalOrdersCountRange.to = this.parametersCustomers.maxTotalOrdersCount : null
                            }
                            if (this.parametersCustomers.maxTotalOrdersAmount || this.parametersCustomers.minTotalOrdersAmount || this.parametersCustomers.minTotalOrdersAmount == 0) {
                                this.form.customersFilters.totalOrdersAmountRange = {}
                                this.parametersCustomers.minTotalOrdersAmount ? this.form.customersFilters.totalOrdersAmountRange.from = this.parametersCustomers.minTotalOrdersAmount : null
                                this.parametersCustomers.maxTotalOrdersAmount ? this.form.customersFilters.totalOrdersAmountRange.to = this.parametersCustomers.maxTotalOrdersAmount : null
                            }
                            this.form.excludeCustomerIds = this.excludeCustomerIds
                            this.form.onlyCustomerIds = []
                        }
                        else {
                            this.form.customersFilters = null
                            this.form.onlyCustomerIds = this.onlyCustomerIds
                            this.form.excludeCustomerIds = []
                        }
                        if (!this.setWalletBalance) {
                            storeService.customersAddWalletBalance(this.storeId, this.form).then(({ data }) => {
                                this.$refs.walletRecharge.reset();
                                this.$notif({ type: 'success' });
                                this.$bvModal.hide('wallet-recharge')
                                this.customersWalletTransactions()
                            })
                                .finally(() => {
                                    this.loadingButton = false
                                });
                        }
                        else {
                            storeService.customersSetWalletBalance(this.storeId, this.form).then(({ data }) => {
                                this.$refs.walletRecharge.reset();
                                this.$notif({ type: 'success' });
                                this.$bvModal.hide('wallet-recharge')
                                this.customersWalletTransactions()
                            })
                                .finally(() => {
                                    this.loadingButton = false
                                });
                        }
                    }
                    else {
                        this.$bvModal.show('customer-choice')
                    }
                }
            });
        },
        getCompletionStatus() {
            this.loadingPage = true;
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified;
                if (this.isAdminIdentityVerified) {
                    this.getUsers()
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        const tomorrow = new Date();
        const today = new Date();
        tomorrow.setDate(today.getDate() + 1);
        this.currentDate = this.formatDate2(tomorrow);
        this.getCompletionStatus()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>